const WA_TEXT = encodeURIComponent(
    "Ciao! Ho visto il vostro sito e vorrei informazioni sulle ripetizioni."
);

export const SITE = {
    brand: "Ripetizioni²",
    price: "10",
    tutors: [
        {
            id: "tommaso",
            name: "Tommaso",
            role: "Matematica & Fisica",
            bio: "Numeri, equazioni, forze e moti: li rende semplici come devono essere. Pazienza infinita, zero panico.",
            phoneDisplay: "+39 351 847 1665",
            phoneHref: "tel:+393518471665",
            whatsapp: `https://wa.me/393518471665?text=${WA_TEXT}`,
            instagram: "https://instagram.com/tommasofrassi_",
            instagramHandle: "@tommasofrassi_",
            symbol: "∑",
            curriculum: [
                "Diploma — Liceo Cecioni, Scienze Applicate (STEM)",
                "Laurea in Matematica — in corso",
            ],
        },
        {
            id: "alessandro",
            name: "Alessandro",
            role: "Matematica & Fisica",
            bio: "Dall'aritmetica all'elettromagnetismo: prima si capisce il perché, poi la formula. Così resta tutto in testa.",
            phoneDisplay: "+39 350 083 7155",
            phoneHref: "tel:+393500837155",
            whatsapp: `https://wa.me/393500837155?text=${WA_TEXT}`,
            instagram: "https://instagram.com/agj_gor",
            instagramHandle: "@agj_gor",
            symbol: "∫",
            curriculum: [
                "Diploma — Liceo Cecioni, Scienze Applicate (STEM)",
                "Laurea in Matematica — in corso",
            ],
        },
    ],
};
